import React, { useState, useEffect } from "react";
import { ArrowUpRight } from "lucide-react";
import { Link } from "../lib/LocalizedLink";
import Reveal from "./Reveal";
import { brand } from "../mock/content";
import { Carousel, CarouselContent, CarouselItem } from "./ui/carousel";
import { optImg } from "../lib/optImg";

const API = process.env.REACT_APP_BACKEND_URL;

const NewsCard = ({ n }) => (
  <Link to={`/news/${n.id}`} className="group block" data-testid={`news-card-${n.id}`}>
    <div className="relative overflow-hidden aspect-[4/3] mb-5">
      <img loading="lazy" decoding="async" src={optImg(n.image)} alt={n.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
      <span className="absolute top-4 left-4 px-3 py-1 text-[11px] uppercase tracking-[0.14em] font-semibold text-black" style={{ background: brand.yellow, fontFamily: "Space Grotesk" }}>
        {n.cat}
      </span>
    </div>
    <h3 className="font-bold text-lg leading-snug group-hover:text-[#F9E212] transition-colors" style={{ fontFamily: "Archivo" }}>
      {n.title}
    </h3>
  </Link>
);

export default function NewsSection() {
  const [items, setItems] = useState([]);
  useEffect(() => {
    fetch(`${API}/api/blog?limit=4`)
      .then((r) => r.json())
      .then((d) => setItems(Array.isArray(d) ? d.slice(0, 4) : []))
      .catch(() => setItems([]));
  }, []);
  if (items.length === 0) return null;
  return (
    <section id="news" className="bg-black text-white py-24 md:py-32">
      <div className="max-w-[1440px] mx-auto px-6 lg:px-10">
        <div className="flex flex-wrap items-end justify-between gap-6 mb-14">
          <Reveal>
            <span className="text-white/60 text-[12px] uppercase tracking-[0.28em]" style={{ fontFamily: "Space Grotesk" }}>
              Dal mondo TORRI
            </span>
            <h2 className="mt-5 font-black leading-[0.9] tracking-tight" style={{ fontFamily: "Archivo", fontSize: "clamp(2.4rem, 6vw, 4.5rem)" }}>
              Ultime notizie
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <Link to="/news" data-testid="news-tutte-link" className="inline-flex items-center gap-2 text-sm uppercase tracking-[0.14em] font-semibold hover:gap-3 transition-all" style={{ fontFamily: "Space Grotesk", color: brand.yellow }}>
              Tutte le news <ArrowUpRight size={16} />
            </Link>
          </Reveal>
        </div>

        {/* Mobile: unico slider */}
        <div className="md:hidden" data-testid="news-slider-mobile">
          <Carousel opts={{ align: "start", loop: true }}>
            <CarouselContent className="-ml-4">
              {items.map((n) => (
                <CarouselItem key={n.id} className="pl-4 basis-[85%]">
                  <NewsCard n={n} />
                </CarouselItem>
              ))}
            </CarouselContent>
          </Carousel>
        </div>

        {/* Desktop: griglia */}
        <div className="hidden md:grid md:grid-cols-2 lg:grid-cols-4 gap-4">
          {items.map((n, i) => (
            <Reveal key={n.id} delay={0.06 * i} y={40}>
              <NewsCard n={n} />
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
